import { XStack, Text } from "tamagui";
const TextSpaceBetween = ({ title, price }: { title: string; price: string }) => {
  return (
    <XStack alignItems="center" justifyContent="space-between" mb={4}>
      <Text fontSize={14}>{title}</Text>
      <Text fontSize={14}>{price}</Text>
    </XStack>
  );
};

export default TextSpaceBetween;
